/**
 * axios setup to use mock service
 */

import axios from 'axios';
import { API_END_POINT } from 'config';

const axiosServices = axios.create({
    // baseURL: 'http://localhost:8080/api/auth'
    baseURL: API_END_POINT
});

const getToken = () => {
    const sessionToken = sessionStorage.getItem("token");
    if (sessionToken) {
        localStorage.removeItem("token");
        return sessionToken;
    }
    return localStorage.getItem("token");

}
// axiosServices.interceptors.request.use(
//     (config) => {
//         config.headers.Authorization = `Bearer ${getToken()}`;
//         return config;
//     },
//     (error) =>
//         // Do something with request error
//         Promise.reject(error)
// );

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.data?.message === "Unauthenticated.") {
            localStorage.clear()
            // window.location.href = "/login";
            // window.location.href = 'http://uat.dfccil.com/DfcHome/Index';
        }
        return Promise.reject((error.response && error.response.data) || 'Wrong Services')
    }
);

export default axiosServices;
